import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { BaseResponse } from 'src/types'
import { UnidadNegocioInsertDTO, UnidadNegocioViewDTO } from './types'

const getEndpoint = (url = '') => `unidad-negocio${url}`

export const HttpUnidadNegocio = {
    getAll: (): Promise<UnidadNegocioViewDTO[]> => {
        return HttpAxiosRequest.get(getEndpoint())
    },

    insert: (data: UnidadNegocioInsertDTO): Promise<any> => {
        return HttpAxiosRequest.post(getEndpoint(), data)
    },

    update: (id: number, data: UnidadNegocioInsertDTO): Promise<BaseResponse> => {
        return HttpAxiosRequest.put(getEndpoint(`/${id}`), data)
    },

    deactivate: (id: number): Promise<BaseResponse> => {
        return HttpAxiosRequest.delete(getEndpoint(`/${id}`))
    },

    activate: (id: number): Promise<BaseResponse> => {
        return HttpAxiosRequest.post(getEndpoint(`/${id}/activar`), {})
    }
}
